import React from 'react';
import './Header.css';

const Header = ({ title = "Locker Management System" }) => {
  return (
    <div className="header">
      <div className="header-container">
        <div className="logo-section">
          <div className="logo-image">
            <img src="/companylogo.png" alt="Company Logo" />
          </div>
        </div>
        <div className="header-link">
          <a href="https://domtom.in" target="_blank" rel="noopener noreferrer">
            Visit Website
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header; 